export default "__VITE_ASSET__05b4a2d3__"